import React from 'react';
import {observer} from 'mobx-react'
import BaseBindedComponent, { BaseBindedComponentProps, BaseBindedComponentState } from '../base-components/BaseBindedComponent'

import {notEmpty} from "../../utils/validation-utils";
import ComponentOuterDiv from "./ComponentOuterDiv";
import {modelValueToDate, dateToLocalDateTimeStr} from "../../utils/datetime-utils";
import moment from "moment";
import { IUIDateTimeColDef, IUIDateTimeDef, IDomainData} from '../../datatypes';
import { DomainAttrInUIComponentProps } from './BaseUIComponent';

const {MDBDatePicker} = require('mdbreact');

const dateTimeformats = {
    'SHORT_FORMAT': 'MM-DD-YYYY HH:mm:ss', 
    'MEDIUM_FORMAT': 'MMM D, YYYY, h:mm:ss A'
} as {[key:string]:string};

interface DatePickerTimeProps extends BaseBindedComponentProps{
    /** @override */
    metadata:IUIDateTimeDef|IUIDateTimeColDef;

    /** @override */
    domainAttribute:DomainAttrInUIComponentProps;    
}

interface DatePickerState extends BaseBindedComponentState{
    
}

class DateTimePicker extends BaseBindedComponent<DatePickerTimeProps, DatePickerState> {

  componentDidMount() {
    super.componentDidMount();
    if(!this.props.metadata.readonly) {
      let validators = [];
      if (this.props.metadata.required) validators.push(notEmpty)

      this.setState({validators: validators})
    }
  }
  onBlur = (e: { target: { value: any; }; }) => {
    const {format} = this.props.metadata;
    let value = e.target.value;
    let dateFormat = format && dateTimeformats[format] ? dateTimeformats[format]: dateTimeformats.SHORT_FORMAT;

    if (!value || !moment(value, dateFormat, true).isValid()) {
      this.onChangeHandler(null, true)
    }
  }

  render() {
    const props = this.props as DatePickerTimeProps & {[key:string]:IDomainData};
  
    const {
      properties,
      label,
      format,
      disabled,
      required,
      readonly,
      cssClasses,
      componentId,
      autoComplete
    } = this.props.metadata;

    let width:string|undefined;
    switch(this.props.metadata.type){
        case 'DateTimeCol': width = this.props.metadata.width;
    }

    let {xs, sm, md, lg} = properties||{};
    let {domainAttribute}= this.props;
    let value = props[domainAttribute.objectName][domainAttribute.name] as string;
    let dateValue = modelValueToDate(value);
    
    let dateFormat = format && dateTimeformats[format] ? dateTimeformats[format]: dateTimeformats.SHORT_FORMAT;

    let requiredClass = required ? ' ui-date-time-input-required' : ''
    let readonlyClass = readonly ? ' ui-date-time-input-readonly' : ''
    let disabledClass = disabled ? ' disabled ui-date-time-input-disabled' : ''
    let className = 'date-time-picker-ui-renderer ' + (cssClasses ? cssClasses : '') + disabledClass + readonlyClass + requiredClass
    let parsedlabel = required || readonly || disabled ? label : label + ' (optional)';
    let tabindex = readonly || disabled ? -1 : 0;
    let id = domainAttribute.namePrefix + componentId
    id = (id.charAt(0).toLowerCase() + id.slice(1)).replace(/\./g, "-");
    let calculatedLabel = this.props.dataGridField ? '' : parsedlabel;
    let hasError = !!this.props.error;

    return (
        <ComponentOuterDiv width={width} dataGridField={!!this.props.dataGridField} xs={xs} sm={sm} md={md} lg={lg}>
          <MDBDatePicker
              autoComplete={autoComplete}
              InputLabelProps={{
                classes: {
                  shrink: "active",
                  root: "no-break",
                  focused: "focused"
                }
              }}
              // placeholder={placeholder}
              className={className}
              tabIndex={tabindex}
              id={id}
              label={calculatedLabel}
              getValue={(val:Date) => {
                if(val && moment(val, dateFormat, true).isValid()){
                  // convert val to YYYY-MM-DDTHH:MI:SS format, which is supported by domain ms
                  if(value !== dateToLocalDateTimeStr(val)) this.onChangeHandler(dateToLocalDateTimeStr(val), true);
                }
              }}
              value={dateValue}
              valueDefault={null}
              disabled ={disabled || readonly}
              format={dateFormat}
              onBlur={(e: { target: { value: any; }; }) => this.onBlur(e)}
              keyboard = {true}
              animateYearScrolling = {false}
              allowKeyboardControl={false}
              disableOpenOnEnter={true}
          />
          <div className={"invalid-feedback date-invalid"} style={{display: hasError && !this.props.metadata.readonly? 'block': 'none'}}>{this.props.error}</div>
        </ComponentOuterDiv>
    )
  }
};

export default observer(DateTimePicker);